module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    style: (_vm.swiperConfig)
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), (!_vm.noArrow) ? _c('div', {
    staticClass: "swiper-button-next"
  }) : _vm._e(), _vm._v(" "), (!_vm.noArrow) ? _c('div', {
    staticClass: "swiper-button-prev"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70719faa"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/swiper/swiper.vue
// module id = 288
// module chunks = 1